import { render, staticRenderFns } from "./companyTermsBox.vue?vue&type=template&id=6717f9fc&"
import script from "./companyTermsBox.vue?vue&type=script&lang=ts&"
export * from "./companyTermsBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports